const client = require("contentful").createClient({
    space: 'wexs6nd26czv',
    accessToken: 'VFShtXaQwcYnIzRdOHZ-Tr7Gq0_6SeAE0Eql5f7z3j8 '
});

const getBlogPosts = () => client.getEntries().then(response => response.items);

const getSinglePost = slug =>
  client
    .getEntries({ 
      "fields.slug": slug,
      content_type: "newBlogPost"
    })
    .then(response => response.items);

export { getBlogPosts, getSinglePost };
